module.exports = __webpack_public_path__ + "img/icon_goauthentication.648ff59f.png";